<template>
  <div>
    <h1 class="mb-6">Test</h1>
    <button @click="post()">test post</button>
  </div>
</template>

<script>
import axios from 'axios'
import endpoints from '../../endpoints'

export default {
  name: 'Test',

  methods: {
    post () {
      axios.post(endpoints.test, {
        'hostId': 123
      })
        .then(response => {
          console.log(response)
        })
        .catch(e => {
          console.error(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/test/index.vue